import { SmallCloseIcon } from '@chakra-ui/icons';
import { Avatar, Box, Button, Flex, Heading, Text, VStack } from '@chakra-ui/react';
import ReactPlayer from 'react-player';
import { ToggleWelcomeMsgMutationFn } from '../../generated/graphql';
import './Dashboard.css';

const copy = {
    welcomeCard: {
        header: 'A message from our CEO 😄',
        body: `The workforce is evolving rapidly! Jobs exist today that didn’t exist 5 years ago and skills you need to learn are often never taught on university campuses.

    Let’s get you prepared for the Future of Work by building skills and experience that will help you land great jobs!

    We’re making it easier than ever before for students to land meaningful internships that lead to future career growth.

    Your PathMatch Profile is a 1-click application for matched internships and jobs.

    Within your PathMatch account you can:
    `,
        bullet1: 'Select your best-matched modern career',
        bullet2: 'Learn about what skills employers look for on resumes',
        bullet3:
            'Create your PathMatch profile that employers can search and find, making it easier to land internships/jobs',
        bullet4: 'Improve your interview skills',
        bullet5: 'Search & apply for internships & jobs',
        avatarName: 'Nancy Soni',
        avatarTitle: 'PathMatch CEO'
    }
};

interface WelcomeCardProps {
    setShouldShowWelcomeMsg: React.Dispatch<React.SetStateAction<boolean>>
    toggleWelcomeMutation: ToggleWelcomeMsgMutationFn
}

export default function WelcomeCard({ setShouldShowWelcomeMsg, toggleWelcomeMutation }: WelcomeCardProps) {


    return (
        <Box className="boxContent" fontSize={{ base: '14px', lg: '16px' }}>
            <Box
                style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'flex-start'
                }}
            >
                <Heading className="boxHeading" fontSize={{ base: '24px', lg: '28px' }}>
                    {copy.welcomeCard.header}
                </Heading>
                <Button
                    size="md"
                    variant="ghost"
                    title="Remove message from our CEO"
                    onClick={async () => {
                        setShouldShowWelcomeMsg(false)
                        toggleWelcomeMutation()
                    }}
                >
                    <SmallCloseIcon />
                </Button>
            </Box>
            <Box height={{ base: '200px', lg: '400px', sm: '170px' }} marginY="20px">
                <ReactPlayer
                    width="100%"
                    height="100%"
                    style={{
                        borderRadius: '20px',
                        overflow: 'hidden'
                    }}
                    url={'https://vimeo.com/664054465'}
                    controls={true}
                />
            </Box>

            <Flex p="2" h="full">
                <Avatar name="Nancy Soni" src="/avatar-nancy.png" />
                <VStack w="full" h="full" ml="4" spacing={0} alignItems="flex-start safe center">
                    <Text className="avatarName" mt="1" fontSize={{ base: '18px' }}>
                        {copy.welcomeCard.avatarName}
                    </Text>
                    <Text className="avatarTitle" fontSize={{ base: '14px' }}>
                        {copy.welcomeCard.avatarTitle}
                    </Text>
                </VStack>
            </Flex>
        </Box>
    );
}
